import React from 'react';
// Components
import Navbar from '../../components/nav/Navbar';
import LoginCard from '../../components/user/LoginCard';

function LoginPage() {
  return (
    <>
      {/* Page */}
      <div className="grid bg-colour4 text-colour2 dark:bg-colour4 dark:text-colour2 h-screen min-h-screen max-h-screen overflow-hidden w-full font-poppins">
        <div className="grid w-full h-full">
          {/* Navigation */}
          <Navbar />

          {/* Main content */}
          <main role="main" className="grid w-full h-full lg:pt-44 items-center overflow-hidden">
            <div className="grid w-full h-full items-center py-2 px-10 overflow-hidden">
              {/* Login component */}
              <LoginCard />
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default LoginPage;
